<template>
    <div>
        <supa-base-header-sec class="mb-0"></supa-base-header-sec>
        <supa-advanced-search-base-header-sec></supa-advanced-search-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" v-on:keyup.enter="search" @reset="onReset">
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у називу</label>
                                <input id="titleQuery" v-model="titleQuery" type="text" class="form-control full-width">
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у тексту</label>
                                <input id="bodyQuery" v-model="bodyQuery" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Врста суда</label>
                                <select v-model="courtType" class="form-control full-width">
                                    <option value="-1">Све остале врсте судова</option>
                                    <option v-for="option in courtTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="courts.length > 0">
                                <label class="form-label">Суд</label>
                                <select v-model="court" class="form-control full-width">
                                    <option value="-1" v-if="courts.length > 1">Сви судови</option>
                                    <option v-for="option in courts" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="departments.length > 0">
                                <label class="form-label">Судско одељење</label>
                                <select v-model="department" class="form-control full-width">
                                    <option value="-1">Сва одељења</option>
                                    <option v-for="option in departments" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Уписник</label>
                                <select v-model="upisnik" class="form-control full-width" :disabled="upisnici.length == 0">
                                    <option value="-1" v-if="upisnici.length > 0">Сви уписници</option>
                                    <option v-for="option in upisnici" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Ознака и број акта </label>
                                <input v-model="actId" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Садржи</label>
                                <select v-model="contentType" class="form-control full-width">
                                    <option v-for="option in contentTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group v-if="contentSubtypes.length > 0" class="form-group-sm">
                                <label class="form-label">Подврста садржаја</label>
                                <select v-model="contentSubtype" class="form-control full-width">
                                    <option v-for="option in contentSubtypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                        </div>
                        <div class="col-md-4">

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Пропис битан за пресуђење</label>
                                <input v-model="essRule" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Чланови</label>
                                <input v-model="articles" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Релевантно право</label>
                                <input v-model="relLaw" type="text" class="form-control full-width">
                            </b-form-group>

                        </div>

                        <div class="col-md-4">

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна област</label>
                                <select v-model="legalAreaId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне области</option>
                                    <option v-for="option in legalAreas" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна материја</label>
                                <select v-model="legalSubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне материје</option>
                                    <option v-for="option in legalSubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm" v-if="legalSubsubjects.length > 0">
                                <label class="form-label">Правна подматерија</label>
                                <select v-model="legalSubsubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне подматерије</option>
                                    <option v-for="option in legalSubsubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Начин објављивања</label>
                                <select v-model="publishingMethod" class="form-control full-width">
                                    <option value="-1" selected="selected">Све врсте објава</option>
                                    <option v-for="option in publishingMethods" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Books -->
                            <b-form-group class="form-group-sm" v-if="books.length > 0">
                                <label class="form-label">Производи/књига</label>
                                <select v-model="book" class="form-control full-width">
                                    <option value="-1" selected="selected">Све</option>
                                    <option v-for="option in books" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Biltens -->
                            <b-form-group class="form-group-sm" v-if="biltens.length > 0">
                                <label class="form-label">Назив билтена</label>
                                <select v-model="bilten" class="form-control full-width">
                                    <option value="-1" selected="selected">Све</option>
                                    <option v-for="option in biltens" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Sites -->
                            <b-form-group class="form-group-sm" v-if="sites.length > 0">
                                <label class="form-label">Адреса сајта</label>
                                <select v-model="site" class="form-control full-width">
                                    <option value="*" selected="selected">Све</option>
                                    <option v-for="option in sites" v-bind:key="option" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Issues -->
                            <div class="row" v-if="years.length > 0">
                                <b-form-group class="form-group-sm col-md-6">
                                    <label class="form-label">Година</label>
                                    <select v-model="year" class="form-control full-width">
                                        <option value="*" selected="selected">Све</option>
                                        <option v-for="option in years" v-bind:key="option" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                </b-form-group>

                                <b-form-group class="form-group-sm col-md-6">
                                    <label class="form-label">Број</label>
                                    <select v-model="issue" class="form-control full-width">
                                        <option value="*" selected="selected">Све</option>
                                        <option v-for="option in issues" v-bind:key="option" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                </b-form-group>
                            </div>

                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум од</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateFrom"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesFrom"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->
                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум до</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateTo"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesTo"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->

                            <data-picker-mask-component ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-component>

                        </div>
                    </div>

                    <div class="spacer20"></div>

                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="resultLimit" class="form-label mr-2">Величина резултата</label>
                                <select id="resultLimit" v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <b-button type="button" @click="search" class="btn btn-base-submit text-uppercase mr-3" v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="reset" class="btn btn-base-reset text-uppercase mr-3">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </b-button>
                            <b-button type="button" class="btn btn-base-reset text-uppercase" @click="copyQuery"
                                v-if="canCopyQuery" style="margin: 5px 0 0 0;">
                                <span class="icon-copy mr-2"></span>
                                Kopiraj upit
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>

            <result-counter :count="resultSize" :limit="limit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <!--                <sorted-table :values="result"-->
                <!--                              sort="timestamp"-->
                <!--                              dir="desc"-->
                <!--                              class="table  table-striped table-sm table-slglrs"-->
                <!--                              ascIcon="<span> ▲</span>"-->
                <!--                              descIcon="<span> ▼</span>">-->
                <!--                    <thead>-->
                <!--                    <tr>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="courtName">Назив суда</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="subjectId">Ознака и број предмета</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="timestamp">Датум доношења</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="name">Ближе одређење материје / назив</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="issuer">Начин објављивања</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="issuePage">Број и страна</sort-link>-->
                <!--                        </th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <template #body="sort">-->
                <!--                        <tbody>-->
                <!--                        <tr v-for="(item, index) in sort.values" v-bind:key="index">-->
                <!--                            <td>{{item.courtName}}</td>-->
                <!--                            <td>{{item.subjectId}}</td>-->
                <!--                            <td>{{item.date}}</td>-->

                <!--                            <td><a :href="baseApiUrl + 'supa/viewAct/naziv-akta/' + item.htmlUuid"-->
                <!--                                   target="_blank">{{item.name}}</a></td>-->
                <!--                            <td>{{item.issuer}}</td>-->
                <!--                            <td>{{item.issuePage}}</td>-->
                <!--                        </tr>-->
                <!--                        </tbody>-->
                <!--                    </template>-->
                <!--                </sorted-table>-->

                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive="sm">
                    <template v-slot:cell(subjectId)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.subjectId
                        }}</router-link>
                    </template>
                    <template v-slot:cell(name)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.name
                        }}</router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SupaBaseHeaderSec from '@/base_pages/supa/SupaBaseHeaderSec.vue';
import SupaAdvancedSearchBaseHeaderSec from '@/base_pages/supa/SupaAdvancedSearchBaseHeaderSec.vue';
// import Datepicker from 'vuejs-datepicker';
// import {SortedTable, SortLink} from "vue-sorted-table";
import { srCYRL } from 'vuejs-datepicker/dist/locale'
import ResultCounter from '@/partials/ResultCounter.vue';

import DataPickerMaskComponent from '@/components/DataPickerMaskComponent.vue';
import { mapState } from 'vuex';


export default {
    name: "SupaAdvancedSearchOcSearchPage",
    data() {
        return {
            limit: 50,
            sortBy: 'timestamp',
            sortDesc: true,
            fields: [
                { label: 'Назив суда', key: 'courtName', sortable: true },
                { label: 'Ознака и број предмета', key: 'subjectId', sortable: true },
                { label: 'Датум доношења', key: 'timestamp', sortable: true },
                { label: 'Ближе одређење материје / назив', key: 'name', sortable: true },
                { label: 'Начин објављивања', key: 'issuer', sortable: true },
                { label: 'Број и страна', key: 'issuePage', sortable: true },
            ],

            emitedDateFromVal: null,
            emitedDateToVal: null,

            srCYRL: srCYRL,

            baseDIApiUrl:window.env.VUE_APP_API_DI_DEV,
            baseSPApiUrl: window.env.VUE_APP_API_SP_DEV,
            resultSize: null,
            result: [],
            courtType: -1,
            contentType: -1,
            contentSubtype: -1,
            court: -1,
            department: -1,
            upisnik: -1,
            book: -1,
            bilten: -1,
            legalAreaId: -1,
            legalSubjectId: -1,
            legalSubsubjectId: -1,
            publishingMethod: -1,
            actId: null,
            titleQuery: null,
            bodyQuery: null,
            essRule: null,
            articles: null,
            relLaw: null,
            dateFrom: null,
            dateTo: null,

            site: '*',
            year: '*',
            issue: '*',

            resultLimit: 50,

            // Collections
            courtTypes: [],
            courts: [],
            departments: [],
            upisnici: [],
            contentTypes: [],
            contentSubtypes: [],
            legalAreas: [],
            legalSubjects: [],
            legalSubsubjects: [],
            publishingMethods: [],
            books: [],
            biltens: [],
            sites: [],
            years: [],
            issues: [],
            resultLimitOptions: [],

            contentTypeQueries: [],
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        SupaBaseHeaderSec,
        SupaAdvancedSearchBaseHeaderSec,
        // Datepicker,
        // SortedTable,
        // SortLink,
        ResultCounter,
        DataPickerMaskComponent
    },
    computed: {
        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('SP')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
        canCopyQuery() {
            if (this.userInfoState && this.searchResult !== null) {
                return this.userInfoState.roles.includes('INTERNAL_USER');
            } return false;
        },
        disabledDatesFrom: function () {
            if (this.dateTo === null) {
                return { from: new Date }
            } else return { from: this.dateTo }
        },
        disabledDatesTo: function () {
            if (this.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.dateFrom, from: new Date }
        }
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        emitedDateFrom(e) {
            this.emitedDateFromVal = e;
        },
        copyQuery() {
            var data = {
                bk: (this.bodyQuery == '') ? null : this.bodyQuery,
                tk: (this.titleQuery == '') ? null : this.titleQuery,
                opid: (this.contentType == 1) ? this.contentSubtype : -1,
                spid: (this.contentType == 0) ? this.contentSubtype : -1,
                limit: this.resultLimit,
                lega: this.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubsubjectId : null,
                bn: (this.publishingMethod == 1) ? (this.issue + '/' + this.year) : null,
                pm: this.publishingMethod,
                desc: (this.contentType == 1),
                other: (this.contentType == 3),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                d: (this.departments.length > 0) ? this.department : null,
                ct: this.courtType,
                c: (this.courts.length > 0) ? this.court : null,
                essRule: (this.essRule == '') ? null : this.essRule,
                articles: (this.articles == '') ? null : this.articles,
                relLaw: (this.relLaw == '') ? null : this.relLaw,
                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,
                bt: this.bilten,
                pspid: this.contentSubtype,
                up: (this.upisnici.length > 0) ? this.upisnik : null,
                act: (this.actId == '') ? null : this.actId,
            }

            var el = document.createElement('textarea');
            el.value = JSON.stringify({
                path: 'api/supa/ocSearch',
                payload: data
            });

            el.style.dislay = 'none';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            alert('Upit je kopiran u clipboard');
        },
        emitedDateTo(e) {
            this.emitedDateToVal = e;
        },
        onReset: function () {
            this.courtType = -1;
            this.contentType = -1;
            this.contentSubtype = -1;
            this.court = -1;
            this.department = -1;
            this.upisnik = -1;
            this.book = -1;
            this.bilten = -1;
            this.legalAreaId = -1;
            this.legalSubjectId = -1;
            this.legalSubsubjectId = -1;
            this.publishingMethod = -1;

            this.actId = null;
            this.titleQuery = null;
            this.bodyQuery = null;
            this.essRule = null;
            this.articles = null;
            this.relLaw = null;
            this.dateFrom = null;
            this.dateTo = null;

            this.emitedDateFromVal = null;
            this.emitedDateToVal = null;

            this.site = '*';
            this.year = '*';
            this.issue = '*';

            this.resultLimit = 50;
            this.result = [];
            this.resultSize = null;
            this.$refs.dataPickerMask.resetDate();
        },
        fetchFilterData: function () {
            axios.get(this.baseSPApiUrl + 'prins/ocSearch/filter')
                .then(response => {
                    this.courtTypes = response.data.courtTypes;
                    this.legalAreas = response.data.legalAreas;
                    this.legalSubjects = response.data.legalSubjects;
                    this.publishingMethods = response.data.publishingMethods;
                });
            axios.get(this.baseSPApiUrl + 'prins/sadrzi/2')
                .then(response => {
                    this.contentTypes = response.data;
                    for (var i = 1; i < this.contentTypes.length; i++) {
                        this.contentTypeQueries[this.contentTypes[i].k] = this.contentTypes[i].query;
                    }
                });
        },
        search: function () {

            // // Local DATA
            // let responseLocal = {"limit":50,"resultSize":23734,"result":[{"htmlUuid":"4ff186bb-f310-d120-9fc3-0ebd7cdc26e0","courtName":"Привредни апелациони суд","subjectId":"Иж 1813/19","name":"Делимично побијање решења о извршењу на основу веродостојне исправе","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"06.12.2019","year":null},{"htmlUuid":"ecccd7d7-bc39-acd0-c650-5fc925f99993","courtName":"Привредни апелациони суд","subjectId":"Пж 5825/19","name":"Основица за обрачун таксе на жалбу","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"28.11.2019","year":null},{"htmlUuid":"7f23671c-0734-b922-5d84-e1865f753171","courtName":"Привредни апелациони суд","subjectId":"Пж 5900/19","name":"Одрицање од достављања писаног отправка одлуке објављене на рочишту","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"28.11.2019","year":null},{"htmlUuid":"8973b2ec-e723-cf4a-50f4-f1a8d0e725e8","courtName":"Привредни апелациони суд","subjectId":"Пж 5900/19 (1)","name":"Тужба за утврђење шта чини заоставштину","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"28.11.2019","year":null},{"htmlUuid":"1f51ee9a-b7c0-ae68-f6e6-89486a943755","courtName":"Привредни апелациони суд","subjectId":"Иж 1759/19","name":"Равноправност странака у извршном поступку","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"28.11.2019","year":null},{"htmlUuid":"c28edfad-36d1-2d28-b562-f308d112aa04","courtName":"Привредни апелациони суд","subjectId":"Иж 1762/19","name":"Извршење према стечајном дужнику","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"28.11.2019","year":null},{"htmlUuid":"2360ac05-dd39-0c03-73d0-53cdc2c2d158","courtName":"Привредни апелациони суд","subjectId":"Иж 1745/19","name":"Уступање предмета суду уговорене месне надлежности","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"22.11.2019","year":null},{"htmlUuid":"44baa74a-2fe1-468c-6800-972e00820998","courtName":"Привредни апелациони суд","subjectId":"Р 31/19","name":"Месна надлежност суда за одлучивање о предлогу за противизвршење трећег лица","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"22.11.2019","year":null},{"htmlUuid":"9ce697d1-2c40-6680-1a88-c98667c2b834","courtName":"Привредни апелациони суд","subjectId":"Иж 1713/19","name":"Дозвољеност жалбе извршног дужника","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"22.11.2019","year":null},{"htmlUuid":"df00d196-6e70-48cf-b3aa-218d0528321c","courtName":"Привредни апелациони суд","subjectId":"Иж 1667/19","name":"Доказ о прелазу обавезе дужника из извршне исправе на друго лице","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"01.11.2019","year":null},{"htmlUuid":"a3fa171f-bad9-cc86-5510-3c7d23b2e394","courtName":"Привредни апелациони суд","subjectId":"Пж 5746/19","name":"Обавезно лично достављање","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"01.11.2019","year":null},{"htmlUuid":"670e8d4c-be39-1221-6762-897fcc62bbf5","courtName":"Привредни апелациони суд","subjectId":"Иж 1618/19","name":"Услови за обуставу извршног поступка","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"31.10.2019","year":null},{"htmlUuid":"98105ae5-63af-dbb2-602d-c0d9e656f2d7","courtName":"Привредни апелациони суд","subjectId":"Пж 5237/19","name":"Рок за плаћање накнаде по Уредби о организовању и извршавању материјалних обавеза","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"24.10.2019","year":null},{"htmlUuid":"ebcde644-9bd9-77f5-4c05-f0d23023b354","courtName":"Привредни апелациони суд","subjectId":"Пж 5322/19","name":"Оцена изведених доказа, као услов за доношење законите одлуке о предлогу за одређивање привремене мере","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"24.10.2019","year":null},{"htmlUuid":"45f4816e-e703-e1f4-93dc-b0ea576a51bb","courtName":"Привредни апелациони суд","subjectId":"Пж 2353/19","name":"Застарелост и начела облигационог права","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"24.10.2019","year":null},{"htmlUuid":"83584be0-8e7d-9e48-b019-5527416c6271","courtName":"Управни суд","subjectId":"9 У 1676/19","name":"Садржина захтева за одређивање садржаја и обима студије о процени утицаја на животну средину","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"24.10.2019","year":null},{"htmlUuid":"138e8bde-b04b-68b0-ca1e-5f7572a17d24","courtName":"Врховни касациони суд","subjectId":"Прев 510/19","name":"Заштита својине","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"24.10.2019","year":null},{"htmlUuid":"4706071b-b4df-cc74-b62e-0a3fb5ea9b94","courtName":"Привредни апелациони суд","subjectId":"Иж 1521/19","name":"Урачунавање испуњења намирењем камате, затим главног дуга","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"17.10.2019","year":null},{"htmlUuid":"b76ace86-d50b-13a8-9612-6a0079ccadc5","courtName":"Привредни апелациони суд","subjectId":"Пж 5384/19","name":"Ограничење законског заступника за заступање привредног друштва уписано у регистар","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"17.10.2019","year":null},{"htmlUuid":"0b28678a-a39c-afd8-6d03-c4d8202200bd","courtName":"Привредни апелациони суд","subjectId":"Р 26/19","name":"Изборна месна надлежност за извршење неновчане обавезе искључења робе из промета","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"17.10.2019","year":null},{"htmlUuid":"378ef227-f6c2-51be-d60d-ce464a73ae03","courtName":"Привредни апелациони суд","subjectId":"Пж 936/19","name":"Губитак својства предузетника у току спора и својство парничне странке и правног субјекта","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"17.10.2019","year":null},{"htmlUuid":"22eb338b-6d50-2048-8c30-1201f86ff7db","courtName":"Привредни апелациони суд","subjectId":"Пж 1601/19","name":"Редослед испуњења одређен од стране дужника","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"17.10.2019","year":null},{"htmlUuid":"0bc39932-5b41-617e-7573-b15ba30bd987","courtName":"Привредни апелациони суд","subjectId":"Пж 1010/19","name":"Камата за период коришћења зајма у привреди","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"17.10.2019","year":null},{"htmlUuid":"9fb98045-4e8f-2d47-158a-c839387d5b0e","courtName":"Привредни апелациони суд","subjectId":"Пж 1558/19","name":"Уговор закључен у име и за рачун предузетника","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"17.10.2019","year":null},{"htmlUuid":"efd2c2c6-34b3-83be-f095-f2ac38734de2","courtName":"Привредни апелациони суд","subjectId":"Иж 1499/19","name":"Услови за одређивање извршења на основу извршне исправе","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"03.10.2019","year":null},{"htmlUuid":"22c796b5-f41a-4737-0d5c-ffccb33d5f7f","courtName":"Управни суд","subjectId":"9 У 8390/19","name":"Обавеза донишења решења по захтеву за остваривање права поводом извршеног увида","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"03.10.2019","year":null},{"htmlUuid":"98455126-f329-b432-7daf-d232dd6ffbca","courtName":"Врховни касациони суд","subjectId":"Рев 3781/19, Рев 3315/19","name":"Заштита од насиља у породици - мере заштите","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"03.10.2019","year":null},{"htmlUuid":"a6da4e02-73bf-29fd-16a6-23509994d21d","courtName":"Врховни касациони суд","subjectId":"Рев 3606/19","name":"Трошкови поступка","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"03.10.2019","year":null},{"htmlUuid":"b6ed99ff-50e9-9d69-fd42-1447b6dadf8c","courtName":"Врховни касациони суд","subjectId":"Рев 2738/19","name":"Заштита од насиља у породици","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"02.10.2019","year":null},{"htmlUuid":"25ce9d8d-2348-da59-f56b-9474bbe7ed63","courtName":"Привредни апелациони суд","subjectId":"Пж 1293/19","name":"Ауторска накнада за јавно извођење музичких дела током организоване приредбе","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"26.09.2019","year":null},{"htmlUuid":"6e36f784-8f58-df10-de24-4f4e1742a2dc","courtName":"Привредни апелациони суд","subjectId":"Пж 3116/19","name":"Активна легитимација за исељење лица које без правног основа држи непокретност","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"26.09.2019","year":null},{"htmlUuid":"e6578ddc-2f75-ab75-5bb5-5152999234a1","courtName":"Привредни апелациони суд","subjectId":"Иж 1417/19","name":"Подаци о потраживањима извршног дужника","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"26.09.2019","year":null},{"htmlUuid":"d8c9c1a8-e139-4e1c-15f0-793a348a34c7","courtName":"Привредни апелациони суд","subjectId":"Пж 972/19","name":"Тужба за утврђење чињенице – повреде вансудског поравнања (уговора)","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"26.09.2019","year":null},{"htmlUuid":"20be167e-bc5e-4da3-9ee7-20bbf31c077e","courtName":"Привредни апелациони суд","subjectId":"Иж 1445/19","name":"Недоспелост потраживања као разлог за изјављивање приговора извршног дужника","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"26.09.2019","year":null},{"htmlUuid":"4e91f315-2fdf-12c2-0a66-4fddb18699ca","courtName":"Привредни апелациони суд","subjectId":"Р 22/19","name":"Месна надлежност суда за одлучивање о приговору извршног дужника против решења о извршењу јавног извршитеља","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"26.09.2019","year":null},{"htmlUuid":"a590d105-bc55-725b-1e49-26f323f8ba21","courtName":"Врховни касациони суд","subjectId":"Рев 1628/19","name":"Вршење родитељског права","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"26.09.2019","year":null},{"htmlUuid":"e06e2248-ee47-da4f-5751-f27f547c7d14","courtName":"Врховни касациони суд","subjectId":"Рев1 13/19","name":"Обнављање списа","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"26.09.2019","year":null},{"htmlUuid":"91163ec6-4c6a-12a7-3ffe-3100b88ff4ce","courtName":"Управни суд","subjectId":"9 У 3184/19","name":"Положај оснивача једночланог привредног друштва","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"19.09.2019","year":null},{"htmlUuid":"5f4a84dc-6366-0433-6be6-22826c0287db","courtName":"Врховни касациони суд","subjectId":"Рев 2648/19","name":"Вршење родитељског права","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"19.09.2019","year":null},{"htmlUuid":"22aadac9-92f1-3a5e-04c0-ddefcf6787c5","courtName":"Врховни касациони суд","subjectId":"Рев 2699/19","name":"Вршење родитељског права","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"19.09.2019","year":null},{"htmlUuid":"3d24df9f-e7b3-a4fc-fc95-a2fb4da57073","courtName":"Врховни касациони суд","subjectId":"Рев 3329/19","name":"Делимично лишење родитељског права","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"18.09.2019","year":null},{"htmlUuid":"810da80b-f539-7083-5fe5-1eb6936bf68a","courtName":"Врховни касациони суд","subjectId":"Рев1 14/19","name":"Накнада због повреде права на правично суђење","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"18.09.2019","year":null},{"htmlUuid":"61cdc08f-872b-52d7-6c6b-e91df4a70792","courtName":"Привредни апелациони суд","subjectId":"Пж 527/19","name":"Уступање потраживања и приговор застарелости","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"13.09.2019","year":null},{"htmlUuid":"f9f3e89e-e2dd-b157-bcd7-74d5351e9149","courtName":"Управни суд","subjectId":"1 У 609/19 (1)","name":"Одлучивање о захтеву за признавање својства странке у управном поступку","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"09.09.2019","year":null},{"htmlUuid":"2f77dacd-c945-703b-4ddb-59ea47f16217","courtName":"Врховни касациони суд","subjectId":"Рев 2682/19","name":"Издржавање детета","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"05.09.2019","year":null},{"htmlUuid":"26fd7fc5-7cf8-cf62-aa02-a4e75789fad2","courtName":"Врховни касациони суд","subjectId":"Рев 2992/19","name":"Заштита од насиља у породици - мере заштите","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"05.09.2019","year":null},{"htmlUuid":"0d0b3c11-2a27-c5e8-5a8c-bf9c5473fee1","courtName":"Врховни касациони суд","subjectId":"Рев 2826/19","name":"Одређивање и престанак издржавања пунолетног детета","issuer":"Сајт","issuePage":"www.vk.sud.rs","date":"05.09.2019","year":null},{"htmlUuid":"083274a1-dbbc-6d10-bede-85cfb164090d","courtName":"Привредни апелациони суд","subjectId":"Пж 4814/19","name":"Отварање поступка принудне ликвидације над дужноком и предлог за одређивање привремене мере","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"29.08.2019","year":null},{"htmlUuid":"08a5f703-91f0-63c6-d7cc-6921b384cf22","courtName":"Привредни апелациони суд","subjectId":"Пж 469/19","name":"Рок за извршење чинидбе изречене судском одлуком и последице протека рока","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"22.08.2019","year":null},{"htmlUuid":"92415def-5015-6631-c211-0cb845966526","courtName":"Привредни апелациони суд","subjectId":"Пж 1436/19","name":"Забрана располагања предметом извршења","issuer":"Правно-информациони систем Републике Србије","issuePage":null,"date":"22.08.2019","year":null}]};                this.result = responseLocal.result;
            // this.result = responseLocal.result;
            // this.resultSize = responseLocal.resultSize;
            // for (var i = 0; i < this.result.length; i++) {
            //     this.result[i].timestamp = moment(this.result[i].date, 'DD.MM.YYYY').valueOf();
            // }

            const vm = this;
            var data = {
                bk: (this.bodyQuery == '') ? null : this.bodyQuery,
                tk: (this.titleQuery == '') ? null : this.titleQuery,
                opid: (this.contentType == 1) ? this.contentSubtype : -1,
                spid: (this.contentType == 0) ? this.contentSubtype : -1,
                limit: this.resultLimit,
                lega: this.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubsubjectId : null,
                bn: (this.publishingMethod == 1) ? (this.issue + '/' + this.year) : null,
                pm: this.publishingMethod,
                desc: (this.contentType == 1),
                other: (this.contentType == 3),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                d: (this.departments.length > 0) ? this.department : null,
                ct: this.courtType,
                c: (this.courts.length > 0) ? this.court : null,
                essRule: (this.essRule == '') ? null : this.essRule,
                articles: (this.articles == '') ? null : this.articles,
                relLaw: (this.relLaw == '') ? null : this.relLaw,
                // df: this.dateFrom,
                // dt: this.dateTo,

                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,
                bt: this.bilten,
                pspid: this.contentSubtype,
                up: (this.upisnici.length > 0) ? this.upisnik : null,
                act: (this.actId == '') ? null : this.actId,
            };
            //added velja and aleksandar
            if (this.publishingMethod == -1) {
                data.bt = this.bilten;
            }
            // publisheMethod Начин објављивања
            if (this.publishingMethod == 3) {
                data.bt = this.book;
            }

            if (this.publishingMethod == 4) {
                data.bn = this.site;
            }

            axios.post(this.baseDIApiUrl + 'sp/advancedSearchOC', data)
                .then(response => {
                    var data = response.data.result;

                    for (var i = 0; i < data.length; i++) {
                        data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                    }

                    this.result = data;
                    this.resultSize = response.data.resultSize;
                    this.limit = response.data.limit;
                }).catch(error => {
                    console.log(error);
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                })
        }
    },
    watch: {
        contentType: function () {
            this.contentSubtype = -1;

            if (this.contentType > -1 && this.contentType != 3) {
                var query = this.contentTypeQueries[this.contentType];
                axios.get(this.baseSPApiUrl + 'prins/2/contentSubtype?obrazlozenje=' + (query.obrazlozenje ? 'true' : 'false')
                    + '&sentenca=' + (query.sentenca ? 'true' : 'false')
                    + '&pravniStav=' + (query.pravniStav ? 'true' : 'false'))
                    .then(response => {
                        this.contentSubtypes = response.data;
                    });
            } else {
                this.contentSubtypes = [];
            }
        },
        courtType: function () {
            this.court =
                this.upisnik = -1;

            if (this.courtType > -1) {
                axios.get(this.baseSPApiUrl + 'Prins/courtsUp/2/' + this.courtType)
                    .then(response => {
                        this.courts = response.data.courts;
                        this.upisnici = response.data.up;

                        if (this.courts.length == 1) {
                            this.court = this.courts[0].k;
                        }
                    })
            } else {
                this.courts =
                    this.upisnici = [];
            }
        },
        court: function () {
            this.department = -1;
            if (this.court > -1) {
                axios.get(this.baseSPApiUrl + 'prins/departments/2/' + this.court)
                    .then(response => {
                        this.departments = response.data
                    });
            } else {
                this.departments = [];
            }
        },
        legalSubjectId: function () {
            this.legalSubsubjectId = -1;
            if (this.legalSubjectId > -1) {
                axios.get(this.baseSPApiUrl + 'prins/legalSubSubject/2/' + this.legalSubjectId)
                    .then(response => {
                        this.legalSubsubjects = response.data
                    })
            } else {
                this.legalSubsubjects = [];
            }
        },
        publishingMethod: function () {
            this.years = [];
            this.issues = [];
            this.sites = [];
            this.biltens = [];
            this.books = [];

            this.year = '*';
            this.issue = '*';
            this.bilten = -1;
            this.book = -1;
            this.site = '*';

            if (this.publishingMethod == 1) {
                axios.get(this.baseSPApiUrl + 'prins/gazette/years/2')
                    .then(response => {
                        this.years = response.data;
                    })
            } else if (this.publishingMethod == 2) {
                axios.get(this.baseSPApiUrl + 'prins/bilteni/2')
                    .then(response => {
                        this.biltens = response.data;
                    })
            } else if (this.publishingMethod == 3) {
                axios.get(this.baseSPApiUrl + 'prins/books/2')
                    .then(response => {
                        this.books = response.data;
                    })
            } else if (this.publishingMethod == 4) {
                axios.get(this.baseSPApiUrl + 'prins/websites/2')
                    .then(response => {
                        this.sites = response.data;
                    })
            }
        },
        year: function () {
            this.issue = '*';
            if (this.year !== '*') {
                axios.get(this.baseSPApiUrl + 'prins/gazette/numbers/2/' + this.year)
                    .then(response => {
                        this.issues = response.data;
                    })
            } else {
                this.issues = [];
            }
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_supa';
    },
    mounted() {
        this.fetchFilterData();
    },
}
</script>

<style >
.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 35%;
}

.table-bootstrap-vue thead tr th:nth-child(5) {
    width: 25%;
}

.table-bootstrap-vue thead tr th:nth-child(6) {
    width: 10%;
}
</style>
